import { jsx } from 'react/jsx-runtime';
import { forwardRef, useEffect } from 'react';
import { useField } from 'formik';
import { TextInput } from '../TextInput/TextInput.js';

const TextField = /*#__PURE__*/forwardRef(function TextField({
  label,
  name,
  validate,
  type,
  multiple,
  initialValue,
  ...rest
}, ref) {
  const [{
    value,
    onChange,
    ...field
  }, meta, {
    setValue,
    setError
  }] = useField({
    name,
    validate,
    type,
    multiple
  });
  useEffect(() => {
    // Trigger validation when remounting on conditional fields
    setValue(value || initialValue);
    return () => {
      setValue(undefined);
      setError(undefined);
    };
  }, []);
  function handleChange(event) {
    if (rest.onChange) {
      rest.onChange(event);
    }
    return onChange(event);
  }
  function handleBlur(event) {
    if (field.onBlur) field.onBlur(event);
    if (rest.onBlur) rest.onBlur(event);
  }
  let errorMessage;
  if (meta.touched && meta.error) {
    errorMessage = meta.error;
  }
  return jsx(TextInput, {
    ref: ref,
    label: label,
    type: type,
    error: errorMessage,
    value: value,
    ...field,
    ...rest,
    onBlur: handleBlur,
    onChange: handleChange
  });
});

export { TextField };
